/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFNameItem } from './CRSFNameItem';
import {
    CRSFNameItemFromJSON,
    CRSFNameItemFromJSONTyped,
    CRSFNameItemToJSON,
} from './CRSFNameItem';

/**
 * 
 * @export
 * @interface CRSFMetaItem
 */
export interface CRSFMetaItem {
    /**
     * 
     * @type {number}
     * @memberof CRSFMetaItem
     */
    ARank?: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFMetaItem
     */
    City?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFMetaItem
     */
    CompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFMetaItem
     */
    Country?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFMetaItem
     */
    Emails?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CRSFMetaItem
     */
    Majestic?: number;
    /**
     * 
     * @type {Array<CRSFNameItem>}
     * @memberof CRSFMetaItem
     */
    Names?: Array<CRSFNameItem>;
    /**
     * 
     * @type {string}
     * @memberof CRSFMetaItem
     */
    Postcode?: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFMetaItem
     */
    QRank?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFMetaItem
     */
    Social?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFMetaItem
     */
    State?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFMetaItem
     */
    Telephones?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CRSFMetaItem
     */
    Umbrella?: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFMetaItem
     */
    Vertical?: string;
}

/**
 * Check if a given object implements the CRSFMetaItem interface.
 */
export function instanceOfCRSFMetaItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFMetaItemFromJSON(json: any): CRSFMetaItem {
    return CRSFMetaItemFromJSONTyped(json, false);
}

export function CRSFMetaItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFMetaItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ARank': !exists(json, 'ARank') ? undefined : json['ARank'],
        'City': !exists(json, 'City') ? undefined : json['City'],
        'CompanyName': !exists(json, 'CompanyName') ? undefined : json['CompanyName'],
        'Country': !exists(json, 'Country') ? undefined : json['Country'],
        'Emails': !exists(json, 'Emails') ? undefined : json['Emails'],
        'Majestic': !exists(json, 'Majestic') ? undefined : json['Majestic'],
        'Names': !exists(json, 'Names') ? undefined : ((json['Names'] as Array<any>).map(CRSFNameItemFromJSON)),
        'Postcode': !exists(json, 'Postcode') ? undefined : json['Postcode'],
        'QRank': !exists(json, 'QRank') ? undefined : json['QRank'],
        'Social': !exists(json, 'Social') ? undefined : json['Social'],
        'State': !exists(json, 'State') ? undefined : json['State'],
        'Telephones': !exists(json, 'Telephones') ? undefined : json['Telephones'],
        'Umbrella': !exists(json, 'Umbrella') ? undefined : json['Umbrella'],
        'Vertical': !exists(json, 'Vertical') ? undefined : json['Vertical'],
    };
}

export function CRSFMetaItemToJSON(value?: CRSFMetaItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ARank': value.ARank,
        'City': value.City,
        'CompanyName': value.CompanyName,
        'Country': value.Country,
        'Emails': value.Emails,
        'Majestic': value.Majestic,
        'Names': value.Names === undefined ? undefined : ((value.Names as Array<any>).map(CRSFNameItemToJSON)),
        'Postcode': value.Postcode,
        'QRank': value.QRank,
        'Social': value.Social,
        'State': value.State,
        'Telephones': value.Telephones,
        'Umbrella': value.Umbrella,
        'Vertical': value.Vertical,
    };
}

